import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const ShopPage = loadable(() => withDefaultLoaderModifiers(import("./ShopPage")));
